/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'xrx-banner',
  templateUrl: './xrx-banner.component.html',
  styleUrls: ['./xrx-banner.component.less'],
  standalone: false,
})
export class XrxBannerComponent {
  @Input() message: string;
  @Output() toggle = new EventEmitter<boolean>();

  constructor() {
    setTimeout(async () => {
      this.close();
    }, 3000);
  }

  close() {
    this.toggle.emit(true);
  }
}
